/* eslint-disable no-new */
import Vue from 'vue/dist/vue.esm.js';
import App from './App.vue';
import router from './router/index.js';
import store from './store';
import AuthService from '@/services/AuthService';
import 'intersection-observer';

// Import dos CSS que são globais
import '@/styles/main.scss';
import '@mdi/font/css/materialdesignicons.min.css';
import 'lodash/lodash.min.js';

// Import das dependências que são globais
import 'bootstrap/dist/js/bootstrap.min.js';
import vueNumeralFilterInstaller from 'vue-numeral-filter';

import '@/assets/flow-icons/style.css';
import '@/assets/vega-icons/style.css';
import '@/assets/lyra-icons/style.css';
import '@/assets/bandeiras/bandeiras.css';

import ElementConfig from './element-config';
import locale from 'element-ui/lib/locale';
import langPt from 'element-ui/lib/locale/lang/pt-br';
import langEn from 'element-ui/lib/locale/lang/en';
import langEs from 'element-ui/lib/locale/lang/es';

import keycloak from 'keycloak-js';

import VueMask from 'v-mask';
import VueTheMask from 'vue-the-mask';
import Vuelidate from 'vuelidate';
import VueIframe from 'vue-iframes';

import VueI18n from 'vue-i18n';

import JsonCSV from 'vue-json-csv';

import { handleImpersonationFlow } from './utils/impersonate';

import keycloakUtil from './utils/keycloak';
import listagemPaginadaMixin from '@/mixins/listagemPaginada';

import VueObserveVisibility from 'vue-observe-visibility';
import AnaliseDesmatamentoModule from '@/modules/analise-desmatamento';
import DenunciaModule from '@/modules/denuncia';
import PreAnaliseModule from './modules/pre-analise-credito';

const InfiniteLoading = () =>
    import('vue-infinite-loading/dist/vue-infinite-loading.js');

window.Vue = Vue;
Vue.config.productionTip = false;

Vue.prototype.$bus = new Vue();
Vue.mixin(listagemPaginadaMixin);

ElementConfig.config();

Vue.use(VueI18n);

const obterContexto = require.context('./locales', true, /\.json$/);
const messages = {};

obterContexto.keys().forEach(fileName => {
    const locale = fileName.split('/')[1];
    const jsonData = obterContexto(fileName);
    if (!messages[locale]) {
        messages[locale] = {};
    }
    messages[locale] = { ...messages[locale], ...jsonData };
});

const i18n = new VueI18n({
    locale: 'pt-BR',
    fallbackLocale: 'pt-BR',
    messages: {
        'pt-BR': JSON.parse(
            JSON.stringify({
                mensagens: messages['pt-br']
            })
        ),
        en: JSON.parse(JSON.stringify({ mensagens: messages['en'] })),
        es: JSON.parse(JSON.stringify({ mensagens: messages['es'] }))
    }
});

function setLocaleElementUI(i18nLocale) {
    switch (i18nLocale) {
        case 'en':
            locale.use(langEn);
            break;
        case 'pt-BR':
            locale.use(langPt);
            break;
        case 'es':
            locale.use(langEs);
            break;
        default:
            locale.use(langPt);
    }
}

Vue.use(VueMask);
Vue.use(VueTheMask);
Vue.use(Vuelidate);
Vue.use(InfiniteLoading);
Vue.use(VueObserveVisibility);
Vue.use(vueNumeralFilterInstaller, { locale: 'pt-br' });
Vue.component('downloadCsv', JsonCSV);
Vue.use(VueIframe);

handleImpersonationFlow().finally(() => {
    let initOptions = {
        url: process.env.VUE_APP_KEYCLOAK_AUTH_URL,
        realm: process.env.VUE_APP_KEYCLOAK_REALM,
        clientId: keycloakUtil.getClientId(),
        onLoad: 'login-required'
    };

    const modules = [AnaliseDesmatamentoModule, DenunciaModule, PreAnaliseModule];
    let kc = keycloak(initOptions);
    kc.init({ onLoad: initOptions.onLoad, checkLoginIframe: false })
        .then(async auth => {
            if (auth) {
                sessionStorage.setItem('jwtToken', kc.token);
                sessionStorage.setItem('refreshToken', kc.refreshToken);
                let userData = await AuthService.buscarDadosUsuarioLogado();

                const userLocale = userData.data.locale || 'pt-BR';
                i18n.locale = userLocale;
                if (document?.documentElement) {
                    document.documentElement.lang = userLocale;
                }
                setLocaleElementUI(i18n.locale);
                ElementConfig.config();
                modules.forEach(module => module.init({ i18n, router }));

                new Vue({
                    i18n,
                    router,
                    store,
                    render: h => h(App, { props: { keycloak: kc } })
                }).$mount('#app');
        }
    })
    .catch(err => {
        // eslint-disable-next-line no-console
        console.error('Authenticated Failed', err);
    });
    kc.onTokenExpired = () => {
        kc.updateToken(30)
            .then(() => {
                sessionStorage.setItem('jwtToken', kc.token);
                sessionStorage.setItem('refreshToken', kc.refreshToken);
            })
            .catch(() => {
                localStorage.removeItem('exportaPDF');
            });
    };
});

export default i18n;
